lazyLoadMerchantLocations = window.lazyLoadMerchantLocations ?= {}

lazyLoadMerchantLocations.reload = (data) ->
  {merchantHtml, merchantModalHtml, merchantSubtitleTooltipHtml, touchRequest} = data

  if merchantHtml.length
    GMap.init data, ->

  if not touchRequest
    if merchantSubtitleTooltipHtml.length
      GIG?.Tooltip?.reloadBindings(document.body)
    if merchantModalHtml.length
      GIG?.Modal?.reloadBindings(el=document.body, unbindFirst=false)

lazyLoadMerchantLocations.ajax_success = (data) ->
  {dealTitleMerchantInfoHtml, merchantHtml, merchantModalHtml, merchantSubtitleTooltipHtml, touchRequest} = data

  if merchantHtml.length
    $('#merchant-locations-placeholder').replaceWith merchantHtml
  else
    $('#merchant-locations-placeholder').remove()

  if dealTitleMerchantInfoHtml.length
    $('.deal-subtitle').replaceWith dealTitleMerchantInfoHtml

  if touchRequest
    if merchantModalHtml.length
      $('.t-main').after merchantModalHtml
  else
    # add tooltips and modals potentially together (one less re-paint)

    $tooltipAndModalData = ""
    if _.isString merchantSubtitleTooltipHtml
      $tooltipAndModalData += merchantSubtitleTooltipHtml
    if _.isString merchantModalHtml
      $tooltipAndModalData += merchantModalHtml

    if $tooltipAndModalData.length
      $lastTooltip = $('.tooltip').last() or $('section.main')
      $lastTooltip.after $tooltipAndModalData

  lazyLoadMerchantLocations.reload(data)

lazyLoadMerchantLocations.init = (payload, done) ->
  {clientSideMerchantLocations} = payload

  unless clientSideMerchantLocations?
    return done()

  $ ->
    $(window).load ->
      $.ajax
        url      : clientSideMerchantLocations.formattedUrl
        dataType : 'json'
        success  : lazyLoadMerchantLocations.ajax_success
        error: (err) ->
          $('#merchant-location-placeholder').remove()
          done()

      done()

module.exports = lazyLoadMerchantLocations
